import { Box } from "@mui/material";
import { format } from "date-fns";
import { t } from "i18next";
import BaseTable from "../../../components/table/BaseTable";
import { useProductOffers } from "../../../services/offersService";
import { OfferStatusText } from "../../OffersPage/OfferStatusText";

const HEADERS = [
    t("products.ProductPassportOffersTable.offerNumber"),
    t("products.ProductPassportOffersTable.sendDate"),
    t("products.ProductPassportOffersTable.customerNames"),
    t("products.ProductPassportOffersTable.customerSurnames"),
    t("products.ProductPassportOffersTable.customerCompanyNames"),
    t("products.ProductPassportOffersTable.investment"),
    t("products.ProductPassportOffersTable.products"),
    t("products.ProductPassportOffersTable.pricesGross"),
    t("products.ProductPassportOffersTable.productStatus"),
];

export function ProductPassportOffersTable(props) {
    const { data: productOffers } = useProductOffers(props.productId, {
        select: (data) =>
            data?.results?.flatMap((offer) => {
                return offer.products
                    .filter((offerProduct) => offerProduct.product.id === props.productId)
                    .map((offerProduct) => {
                        const customerNames = offer.customers
                            .map((oc) => oc.customer.name || "-")
                            .join("\n");
                        const customerSurnames = offer.customers
                            .map((oc) => oc.customer.last_name || "-")
                            .join("\n");

                        const customerCompanyNames = offer.customers
                            .map((oc) => oc.customer.company_name || "-")
                            .join("\n");

                        const allProductNames = offer.products
                            .filter((op) => op.status.status_key !== "RemovedFromOffer")
                            .map((op) => op.product.name_full)
                            .join("\n");

                        const allPrices = offer.products
                            .filter((op) => op.status.status_key !== "RemovedFromOffer")
                            .map(
                                (op) =>
                                    op.price_after_discount?.toFixed(2) ||
                                    op.listed_price?.toFixed(2) ||
                                    "-",
                            )
                            .join("\n");

                        return {
                            rowId: `${offer.id}-${offerProduct.id}`,
                            data: [
                                offer.offer_nr,
                                offer.date_created
                                    ? format(new Date(offer.date_created), "yyyy-MM-dd")
                                    : "-",
                                customerNames,
                                customerSurnames,
                                customerCompanyNames,
                                offer.investment_name,
                                allProductNames,
                                allPrices,
                                <OfferStatusText status={offerProduct.status} />,
                            ],
                        };
                    });
            }) || [],
    });

    return (
        <Box sx={{ maxHeight: 200, overflow: "auto", borderRadius: 1 }}>
            <BaseTable
                stickyHeader={true}
                headers={HEADERS}
                rows={productOffers || []}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                hiddenColumns={[]}
                selectedRows={[]}
            />
        </Box>
    );
}
